import React, { useState } from 'react';
import { List } from 'immutable';
import { useTranslation } from 'react-i18next';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import {
  WEBFORM_APPLY_FOR_ACTIVITY,
} from '../../../../config/constants';
import Webform from '../../../../components/Webform';

import './style.scss';

const ActivityForm = ({
  entity,
  selectedDate,
}) => {
  const { t } = useTranslation();

  const nid = entity.getIn(['nid', 0, 'value'], '');
  const dateRanges = entity.getIn(['field_date_ranges', 0, 'dates'], List());
  const receiverEmail = entity.getIn(['field_response_email', 0, 'value'], 'ikdoemee@deregenboog.org');
  const locationName = entity.getIn(['field_location', 0, 'entity', 'name', 0, 'value'], '');
  const locationAddress = entity.getIn(['field_location', 0, 'entity', 'field_address', 0], '');

  const [showNoDateError, setShowNoDateError] = useState(false);

  return (
    <div className="AcitivityForm">
      {selectedDate !== null && (
        <Container className="ActivityForm__form">
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              <Webform
                displayRequiredIndicator="optional"
                scrollToTopAfterSubmit={false}
                scrollToTopAfterMultiFormStep={false}
                id={WEBFORM_APPLY_FOR_ACTIVITY}
                initialValues={{
                  activity: nid,
                  date: new Date(dateRanges.getIn([selectedDate, 'start', 'date'])).toISOString(),
                  receiver_email: receiverEmail,
                }}
              />
            </div>
          </div>
        </Container>
      )}
      {selectedDate === null && dateRanges.size > 0 && (locationName && locationAddress) && (
        <Container className="ActivityForm__form ActivityForm__onlyButton">
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              <button className="Button WebformComponent__submit__next" type="button" onClick={() => setShowNoDateError(true)}>{t('webform.activity_submit')}</button>
              {showNoDateError && (
                <p className="caption">{t('webform.activity_no_date_error')}</p>
              )}
            </div>
          </div>
        </Container>
      )}
    </div>
  );
};

export default ActivityForm;
